import React, { useState, useContext, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";

import SuiBox from "components/SuiBox";
import Modal from "@mui/material/Modal";
import Card from "@mui/material/Card";

import ImageCardWrapper from "components/UpStyled/ImageCardWrapper";
import SuiTypography from "components/SuiTypography";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import SuiButton from "components/SuiButton";
import DownloadIcon from "@mui/icons-material/Download";
import { detailAILabUrlPrefix } from "utils/data";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  borderRadius: 0,
  border: "none",
  bgcolor: "background.paper",
  maxHeight: "90vh",
  overflow: "auto",
  maxWidth: 800,
  boxShadow: 24,
  p: 4,
};

const FlatDrawingDetailModal = ({ detail, visible, handleClose, handleDownloadAll }) => {
  const [isHover, setIsHover] = useState(false);
  const navigate = useNavigate();

  return (
    <Modal open={visible} onClose={handleClose}>
      <Card style={style}>
        <div>
          <SuiBox
            display="flex"
            position="relative"
            justifyContent="space-between"
            alignItems="center"
            my={0.5}
          >
            <SuiTypography variant="h6" sx={{ ml: 2 }}>
              {detail?.title}
            </SuiTypography>
            <IconButton
              aria-label="close"
              onClick={() => handleClose()}
              sx={{
                color: (theme) => theme.palette.grey[600],
              }}
            >
              <CloseIcon />
            </IconButton>
          </SuiBox>
          <div className="hover-parent">
            <ImageCardWrapper
              data={detail?.img}
              height={"auto"}
              width={"100%"}
              minHeight={400}
              maxHeight={600}
              minWidth={400}
              isOriginalSize
              draggable={false}
            />
            <div style={{ position: "absolute" }} className="overlay">
              <SuiBox sx={{ maxWidth: 320, mx: "auto" }}>
                {detail?.img?.url ? (
                  <SuiButton
                    variant="gradient"
                    color="white"
                    sx={{
                      textTransform: "capitalize",
                      fontSize: 14,
                      width: "100%",
                      mb: 1,
                    }}
                    onClick={() => navigate(`${detailAILabUrlPrefix}?img=${detail?.img?.url}`)}
                  >
                    Start in AI Design
                  </SuiButton>
                ) : null}
                <SuiButton
                  variant="gradient"
                  color="white"
                  sx={{ textTransform: "capitalize", fontSize: 14, width: "100%" }}
                  onClick={handleDownloadAll}
                >
                  Download
                </SuiButton>
              </SuiBox>
            </div>
          </div>
        </div>
      </Card>
    </Modal>
  );
};
export default FlatDrawingDetailModal;
